<button mat-icon-button [matMenuTriggerFor]="menu"  class="profile-menu-btn" aria-label="profile-menu"
  [matTooltip]="profileMenuTooltip">
  <mat-icon [ngClass]="{ 'icon-color-header': utilities.isSelectClientRoute() || utilities.isOnboardingRoute()}">person</mat-icon>
</button>
<mat-menu #menu="matMenu" class="profile-menu-list">
  <button *ngIf="!utilities.isSelectClientRoute()" mat-menu-item (click)="route.navigate(['client',clientId,'user-profile'])">
    <mat-icon>person</mat-icon>
    <span i18n>My Profile</span>
  </button>
  <button *ngIf="isOnboarding" mat-menu-item (click)="backToOnboarding()">
    <mat-icon>hail</mat-icon>
    <span i18n>Onboarding Wizard</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span i18n>Logout</span>
  </button>
</mat-menu>